<template>
    <div>
        <div class=" overflow-hidden mt-5" >
        <b-row class="mt-5">
  <b-col cols="12" class="mt-3">
    <b-skeleton-img no-aspect height="550px" ></b-skeleton-img>
  </b-col>
</b-row>

    </div>
    </div>
</template>

<script>
export default {
    name: 'SolimanologSpinner',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style  scoped>
.skeleton-image {
  width: 100%; /* Establece un ancho deseado para el skeleton-image */
}

</style>